import React, { FC } from 'react';

type Props = {
    urlKey: string;
    productId: number;
};

export const YotpoRating: FC<Props> = ({ productId }) =>
    productId ? <div className="yotpo bottomLine" data-yotpo-product-id={productId} /> : null;
